import { OrderType } from '../schemas';
import { daiCostsFields } from './consistent';

/**
 * 表示項目一覧
 */
export type DaiCostsField = (typeof daiCostsFields)[number]['code'];

/**
 * [機械代金登録] テーブルデータのレスポンス
 * GET /settings/daiCosts
 */
export type SettingsDaiCostsResponse = {
  setting: {
    startDate: string;
    endDate: string;
    sort: DaiCostsField;
    order: OrderType;
  };
  data: {
    initialHallName: string;
    currentHallName: string;
    mainBoardNo: string;
    kiMei: string;
    donyuDay: string;
    konyuKbn: string;
    konyuGaku: number | null;
    syoruiGaku: number | null;
    saleGaku: number | null;
    saleDay: string | null;
  }[];
};

/**
 * [機械代金登録] テーブルデータのリクエストパラメータ
 * GET /settings/daiCosts
 */
export type DaiCostsApiSearchParams = {
  startDate?: string;
  endDate?: string;
};

/**
 * [機械代金登録] 画面の検索・ソート状態
 * sort / order はフロント側ソート用（API には送らない）
 */
export type DaiCostsSearchParams = DaiCostsApiSearchParams & {
  sort?: DaiCostsField;
  order?: OrderType;
};

export const toDaiCostsApiSearchParams = (
  params: DaiCostsSearchParams | undefined
): DaiCostsApiSearchParams => {
  if (params == null) {
    return {};
  }

  const { startDate, endDate } = params;

  return {
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {}),
  };
};

/**
 * [機械代金登録] 機械代金登録CSVデータアップロード
 * POST /settings/daiCosts
 */
export type PostDaiCostsResponse = {
  data: {
    initialHallName: string;
    currentHallName: string;
    mainBoardNo: string;
    kiMei: string;
    donyuDay: string;
    konyuKbn: string;
    konyuGaku: number;
    syoruiGaku: number;
    saleGaku: number;
    saleDay: string;
  }[];
};

/**
 * [機械代金登録] 機械代金登録CSVデータアップロード 422エラーレスポンス
 * POST /settings/daiCosts
 */
export type PostDaiCostsErrorResponse = {
  statusCode: string;
  error: string;
  message: string;
  details: string[];
};
